import PropTypes from "prop-types";
import React, { useState, useEffect, useContext } from "react";
import { Link } from "react-router-dom";
import { animateScroll } from "react-scroll";
import FooterCopyright from "../../components/footer/FooterCopyright";
import FooterNewsletter from "../../components/footer/FooterNewsletter";
import StaticContent from "../../context/ContentContext";


const FooterOne = ({
  backgroundColorClass,
  spaceTopClass,
  spaceBottomClass,
  spaceLeftClass,
  spaceRightClass,
  containerClass,
  extraFooterClass,
  sideMenu
}) => {
  const [scroll, setScroll] = useState(0);
  const [top, setTop] = useState(0);
  const menuJson = useContext(StaticContent);

  const footerData = menuJson && menuJson?.content?.contentManagement?.data?.content?.items[0]?.footer

  useEffect(() => {
    setTop(100);
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const scrollToTop = () => {
    animateScroll.scrollToTop();
  };

  const handleScroll = () => {
    setScroll(window.scrollY);
  };
  return (
    <footer
      className={`footer-area ${
        backgroundColorClass ? backgroundColorClass : ""
      } ${spaceTopClass ? spaceTopClass : ""} ${
        spaceBottomClass ? spaceBottomClass : ""
      } ${extraFooterClass ? extraFooterClass : ""} ${
        spaceLeftClass ? spaceLeftClass : ""
      } ${spaceRightClass ? spaceRightClass : ""}`}
    >
      <div className={`${containerClass ? containerClass : "container"}`}>
        <div className="row" style={{ placeContent: 'center', textAlign: 'center'}}>
          <div
            className={`${
              sideMenu ? "col-xl-2 col-md-12 col-sm-4" : "col-lg-2 col-md-12 col-sm-12"
            }`}
          >
            {/* footer copyright */}
            <FooterCopyright
              footerLogo={footerData?.footerCopyrightSection?.footerLogo}
              copyRightCompanyName={footerData?.footerCopyrightSection?.copyRightCompanyName}
              copyRightCompanyLink={footerData?.footerCopyrightSection?.copyRightCompanyLink}
              spaceBottomClass="mb-30"
            />
          </div>
          <div
            className={`${
              sideMenu ? "col-xl-2 col-md-12 col-sm-4" : "col-lg-2 col-md-12 col-sm-12"
            }`}
          >
            <div className="footer-widget mb-30 ml-30">
              <div className="footer-title">
                <h3>{footerData?.footerSectionFirst?.title}</h3>
              </div>
              <div className="footer-list">
                <ul>
                  {footerData?.footerSectionFirst?.items.map((data, idx) => {
                  if (data?.link?.indexOf('.com') === -1) {
                    return(
                      <li key={idx}>
                      <Link to={process.env.PUBLIC_URL + data.link}>{data.text}</Link>
                    </li>
                    )
                  }
                  return(
                    <li>
                    <a href={data.link}
                      target="_blank"
                      rel="noopener noreferrer">{data.text}</a>
                  </li>
                  )})}
                </ul>
              </div>
            </div>
          </div>
          <div
            className={`${
              sideMenu ? "col-xl-2 col-md-12 col-sm-4" : "col-lg-2 col-md-12 col-sm-12"
            }`}
          >
            <div
              className={`${
                sideMenu
                  ? "footer-widget mb-30 ml-95"
                  : "footer-widget mb-30 ml-50"
              }`}
            >
              <div className="footer-title">
                <h3>{footerData?.footerSectionSecond?.title}</h3>
              </div>
              <div className="footer-list">
                <ul>
                {footerData?.footerSectionSecond?.items.map((data,idx) => {
                  if (data?.link?.indexOf('.com') === -1) {
                    return(
                      <li key={idx}>
                      <Link to={process.env.PUBLIC_URL + data.link}>{data.text}</Link>
                    </li>
                    )
                  }
                  return(
                    <li>
                    <a href={data.link}
                      target="_blank"
                      rel="noopener noreferrer">{data.text}</a>
                  </li>
                  )})}
                </ul>
              </div>
            </div>
          </div>
          <div
            className={`${
              sideMenu ? "col-xl-3 col-md-12 col-sm-4" : "col-lg-2 col-md-12 col-sm-12"
            }`}
          >
            <div
              className={`${
                sideMenu
                  ? "footer-widget mb-30 ml-145"
                  : "footer-widget mb-30 ml-75"
              }`}
            >
              <div className="footer-title">
                <h3>{footerData?.footerSectionThird?.title}</h3>
              </div>
              <div className="footer-list">
                <ul>
                {footerData?.footerSectionThird?.items.map((data, idx) => {
                  if (data?.link?.indexOf('.com') === -1) {
                    return(
                      <li key={idx}>
                      <Link to={process.env.PUBLIC_URL + data.link}>{data.text}</Link>
                    </li>
                    )
                  }
                  return(
                    <li>
                    <a href={data.link}
                      target="_blank"
                      rel="noopener noreferrer">{data.text}</a>
                  </li>
                  )})}
                </ul>
              </div>
            </div>
          </div>
        </div>-

        <p style={{ textAlign: 'center'}}>
                &copy; {new Date().getFullYear()}{" "}
                <a
                  href={footerData?.footerCopyrightSection?.copyRightCompanyLink || "https://jthanna.jthanna.com/"}
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  {footerData?.footerCopyrightSection?.copyRightCompanyName || "JT Hanna"}
                </a>
                .<br /> All Rights Reserved
              </p>
        
      </div>
      <button
        className={`scroll-top ${scroll > top ? "show" : ""}`}
        onClick={() => scrollToTop()}
      >
        <i className="fa fa-angle-double-up"></i>
      </button>
    </footer>
  );
};

FooterOne.propTypes = {
  backgroundColorClass: PropTypes.string,
  containerClass: PropTypes.string,
  extraFooterClass: PropTypes.string,
  sideMenu: PropTypes.bool,
  spaceBottomClass: PropTypes.string,
  spaceTopClass: PropTypes.string,
  spaceLeftClass: PropTypes.string,
  spaceRightClass: PropTypes.string
};

export default FooterOne;
